import { useEffect, useState } from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const sections = [
  { id: "top", n: "01", label: "Hero" },
  { id: "services", n: "02", label: "Services" },
  { id: "methode", n: "03", label: "Méthode" },
  { id: "projets", n: "04", label: "Projets" },
  { id: "faq", n: "07", label: "FAQ" },
  { id: "contact", n: "08", label: "Contact" },
];

export default function ScrollIndicator() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { damping: 30, stiffness: 200 });
  const [active, setActive] = useState("top");

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY + window.innerHeight * 0.4;
      let current = sections[0].id;
      for (const s of sections) {
        const el = document.getElementById(s.id);
        if (el && el.offsetTop <= y) current = s.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top progress bar */}
      <motion.div
        data-testid="scroll-progress-bar"
        className="fixed top-0 left-0 right-0 h-[2px] bg-[var(--accent)] z-[55] origin-left"
        style={{ scaleX: progress }}
      />

      {/* Right rail with section dots */}
      <div
        data-testid="scroll-rail"
        className="hidden lg:flex flex-col gap-5 fixed right-6 top-1/2 -translate-y-1/2 z-[45] mix-blend-difference"
      >
        {sections.map((s) => (
          <a
            key={s.id}
            href={`#${s.id}`}
            data-testid={`scroll-dot-${s.id}`}
            className="group flex items-center gap-3 justify-end"
            aria-label={`Aller à ${s.label}`}
          >
            <span
              className={`font-mono text-[10px] uppercase tracking-[0.25em] transition-all duration-300 ${
                active === s.id ? "opacity-100 text-white" : "opacity-0 -translate-x-2 group-hover:opacity-70 group-hover:translate-x-0 text-white"
              }`}
            >
              {s.label}
            </span>
            <span
              className={`block rounded-full transition-all duration-300 ${
                active === s.id
                  ? "w-2.5 h-2.5 bg-white"
                  : "w-1.5 h-1.5 bg-white/30 group-hover:bg-white/70"
              }`}
            />
          </a>
        ))}
      </div>
    </>
  );
}
